<template>
<div class="k-user">
    <img :src="logo" class="k-user__logo">
    <span class="k-user__nick">{{nick}}</span>
</div>
</template>

<script>
    export default {
        name: 'k-user',
        props: ['nick', 'logo']
    }
</script>
